import React from "react";
import PropTypes from "prop-types";

import { getEltAndAccessor, getEltAndAccessorNumber } from "./common/helpers";
import DataGrid from "../../Components/DataGrid";
import { caseInsensitiveFilter } from "./common/ResourcesTable";

import "./common/ResourcesTable.scss";

/*
Constants and Helpers
*/

export const getRows = ({ data, onClickIp = () => () => {} }) => {
  const rows = data.map((elt) => {
    const {
      groupedCount: total,

      ipAddress: source,
      ipId: sourceId,

      name: vuln,
      // id: vulnId,

      otherAddress: destination,
      otherId: destinationId,
    } = elt;

    // Destination
    const { accessor: destinationAccessor, element: destinationElt } =
      getEltAndAccessor({
        clickable: !!destinationId,
        label: destination,
        onClickElt: onClickIp(destinationId),
      });

    // Source
    const { accessor: sourceAccessor, element: sourceElt } = getEltAndAccessor({
      clickable: !!sourceId,
      label: source,
      onClickElt: onClickIp(sourceId),
    });

    // Volume
    const { accessor: totalAccessor, element: totalElt } =
      getEltAndAccessorNumber(total);

    // Vuln
    const vulnAccessor = vuln;
    const vulnElt = <div>{vuln}</div>;

    return {
      destination: destinationElt,
      destinationAccessor,

      source: sourceElt,
      sourceAccessor,

      vuln: vulnElt,
      vulnAccessor,

      total: <div className="number-column">{totalElt}</div>,
      totalAccessor,
    };
  });

  return rows;
};

const COLUMNS = [
  {
    Header: "Source",
    accessor: "sourceAccessor",
    filterable: true,
    sortable: true,
    Cell: (row) => row.original.source,
    maxWidth: 180,
    minWidth: 140,
    filterMethod: caseInsensitiveFilter(),
  },
  {
    Header: "Destination",
    accessor: "destinationAccessor",
    filterable: true,
    sortable: true,
    Cell: (row) => row.original.destination,
    maxWidth: 180,
    minWidth: 140,
    filterMethod: caseInsensitiveFilter(),
  },
  {
    Header: "Vuln",
    accessor: "vulnAccessor",
    filterable: true,
    sortable: true,
    Cell: (row) => row.original.vuln,
    maxWidth: 280,
    minWidth: 220,
    filterMethod: caseInsensitiveFilter(),
  },
  {
    Header: <div className="number-column">Total</div>,
    accessor: "totalAccessor",
    filterable: false,
    sortable: true,
    Cell: (row) => row.original.total,
    maxWidth: 80,
    minWidth: 80,
    filterMethod: caseInsensitiveFilter(),
  },
];

/*
Component
*/

const ThreatsTable = (props) => {
  const { data } = props;

  return (
    <div className="resources-table">
      <DataGrid
        defaultPageSize={10}
        data={data}
        columns={COLUMNS}
        showPagination={false}
      />
    </div>
  );
};

ThreatsTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
};

ThreatsTable.defaultProps = {
  data: [],
};

export default ThreatsTable;
